import React from 'react';
import SuccessScreen from '../../Common/SuccessScreen';

const PaymentPending = () => (
  <SuccessScreen
    icon='https://d2djimvzddgguw.cloudfront.net/humbee-payments/disclaimer-icon.svg'
    title="Payment pending!"
    subtitle="This may take a few minutes. Please check after some time."
  />
);

export default PaymentPending;
